import React, { cloneElement, ReactElement, useState } from 'react';
import { CommonInputProps, required, useGetOne, usePermissions } from 'react-admin';
import { getChainId } from '../../lib';
import { PERMISSIONS } from '../../constants';

export enum ValidationRuleKey {
  requiredEncerrante = 'mustInformEncerrante',
  requiredHoseNumber = 'mustInformHoseNumber',
}

interface CheckChainUsesValidation {
  children: ReactElement;
  ruleKey: ValidationRuleKey;
}

const validationRulesMap: Record<ValidationRuleKey, Omit<CommonInputProps, "source">> = {
  [ValidationRuleKey.requiredEncerrante]: {
    validate: [required()]
  },
  [ValidationRuleKey.requiredHoseNumber]: {
    validate: [required()]
  }
}

const CheckChainUsesValidation: React.FC<CheckChainUsesValidation & Omit<CommonInputProps, "source">> = ({ children, ruleKey }) => {
  const [chainId] = useState(getChainId());
  const { permissions } = usePermissions();
  const isAdmin = permissions && permissions.includes(PERMISSIONS.ADMIN);

  if (!chainId && isAdmin) { cloneElement(children); }

  const { data: chain } = useGetOne('chains', { id: chainId });

  const inputProps = validationRulesMap[ruleKey] || {};

  return (chain && chain[ruleKey] === true) ? cloneElement(children, inputProps) : children
}
export default CheckChainUsesValidation;